export default {
  productCol: {
    gridColumn: [`span 12`, `span 12`, `span 12`, `span 8`, `span 8`, `span 6`]
  },
  specialCol: {
    gridColumn: [`span 24`, `span 24`, `span 24`, `span 16`, `span 16`, `span 12`]
  }
};